// avstemming-vat-messages translations (Norwegian source catalog).
window.PlummeI18n.register('no', {
  'avf.common.matches': 'Stemmer',
  'avf.common.submitted': 'Levert',
  'avf.common.notSubmitted': 'Ikke levert',
  'avf.common.complete': 'Komplett',
  'avf.common.differences': '{count} differanse',
  'avf.common.difference': 'Differanse',
  'avf.common.needsAssessment': 'Krever vurdering',
  'avf.common.status': 'Status',
  'avf.common.all': 'Alle',
  'avf.common.missingTreatment': 'Avgiftsbehandling ikke fastsatt',
  'avf.common.directPosting': 'Direkteføring',
  'avf.common.postedDirectly': 'Direkteført på MVA-konto',
  'avf.common.noDeduction': 'Ingen fradragsrett',
  'avf.common.partialDeduction': 'Delvis fradragsrett',
  'avf.common.reverseCharge': 'Omvendt avgiftsplikt',
  'avf.common.salesWithoutVat': 'Salg uten MVA',
  'avf.common.creditNotes': 'Kreditnotaer',
  'avf.common.assessed': 'Ferdig vurdert',
  'avf.common.salesOutgoing': 'Salg og utgående MVA',
  'avf.common.purchasesIncoming': 'Kjøp og inngående MVA',
  'avf.common.sales': 'Salg',
  'avf.common.purchases': 'Kjøp',
  'avf.common.foreign': 'Utland',
  'avf.common.assess': 'Vurder',
  'avf.common.viewAssessment': 'Se vurdering',
  'avf.common.requestDocs': 'Be klienten om dokumentasjon',
  'avf.common.close': 'Lukk',
  'avf.common.followUpNext': 'Følges opp neste termin',
  'avf.common.missing': 'Mangler',
  'avf.common.outgoingInTerm': 'Utgående MVA i terminen',
  'avf.common.incomingInTerm': 'Inngående MVA i terminen',
  'avf.common.filingDeadline': 'Leveringsfrist',
  'avf.common.reportingPeriod': 'Rapporteringsperiode',
  'avf.common.documentation': 'Dokumentasjon',
  'avf.common.filingTitle': 'MVA-melding',
  'avf.common.col.document': 'Dokument',
  'avf.common.col.documentDate': 'Dokumentdato',
  'avf.common.col.account': 'Konto',
  'avf.common.col.vatCode': 'MVA-kode',
  'avf.common.col.vatAmount': 'MVA-beløp',
  'avf.common.col.rate': 'Sats',
  'avf.common.col.warning': 'Varsel',
  'avf.common.col.assessment': 'Vurdering',
  'avf.common.col.counterparty': 'Motpart',
  'avf.common.col.type': 'Type',
  'avf.common.col.basis': 'Grunnlag',
  'avf.common.col.date': 'Dato',
  'avf.common.col.amount': 'Beløp',
  'avf.common.col.deductionRate': 'Fradragsgrad',
  'avf.term.monthly': 'Månedlig',
  'avf.term.bimonthly': 'Tomånedlig',
  'avf.term.quarterly': 'Kvartalsvis',
  'avf.term.semiannual': 'Halvårlig',
  'avf.term.annual': 'Årlig',
  'avf.assess.notAssessed': 'Ikke vurdert',
  'avf.assess.noCorrection': 'Ingen korrigering nødvendig',
  'avf.assess.missingCode': 'Manglende MVA-kode',
  'avf.assess.wrongCode': 'Feil MVA-kode',
  'avf.assess.wrongRate': 'Feil sats',
  'avf.assess.limitedDeduction': 'Begrenset fradragsrett',
  'avf.assess.importVat': 'Innførselsmerverdiavgift',
  'avf.assess.wrongTerm': 'Rapportert i feil termin',
  'avf.assess.duplicate': 'Duplikat',
  'avf.assess.awaitingDocs': 'Avventer dokumentasjon',
  'avf.assess.awaitingClient': 'Avventer klienten',
  'avf.page.noAccount': 'MVA-området har ingen avstemmingskonto i denne perioden.',
  'avf.page.nav.overview': 'Oversikt',
  'avf.page.nav.codes': 'MVA-koder og grunnlag',
  'avf.page.nav.codesCount': '{count} koder',
  'avf.page.nav.toAssess': '{count} til vurdering',
  'avf.page.nav.foreign': 'Utland og import',
  'avf.page.nav.items': '{count} poster',
  'avf.page.nav.accounts': 'MVA-kontoer',
  'avf.page.nav.accountsCount': '{count} kontoer',
  'avf.page.nav.filing': 'MVA-melding og oppgjør',
  'avf.page.nav.deviations': 'Avvik og tiltak',
  'avf.page.nav.open': '{count} åpne',
  'avf.page.nav.missing': '{count} mangler',
  'avf.page.nav.controls': 'Kontroll og godkjenning',
  'avf.page.areaFallback': 'MVA',
  'avf.page.hintOpen': '{count} transaksjon(er) med varsel er ikke ferdig vurdert.',
  'avf.page.hintDone': 'Alle transaksjoner med varsel er vurdert.',
  'avf.page.title': 'MVA — transaksjonsgrunnlag, hovedbok og MVA-melding',
  'avf.page.reconciledIn': 'Avstemmes i {period}',
  'avf.page.responsible': 'Ansvarlig {name}',
  'avf.page.notRegisteredBadge': 'Ikke MVA-registrert',
  'avf.page.termOver': 'Terminen er over',
  'avf.page.termRunning': 'Terminen løper',
  'avf.page.orgNumber': 'Organisasjonsnummer',
  'avf.page.termLength': 'Terminlengde',
  'avf.page.netInTerm': 'Netto MVA i terminen',
  'avf.page.termNotOver': 'Terminen er ikke over.',
  'avf.page.termEnds': '{period} {year} avsluttes {date}, og MVA-avstemmingen hører hjemme i den måneden.',
  'avf.page.termSoFar': 'Tallene under er terminen så langt. Området teller ikke mot fremdriften i denne perioden.',
  'avf.page.notRegistered': 'Foretaket er ikke registrert i Merverdiavgiftsregisteret i innstillingene. Er det likevel bokført MVA i perioden, er det registreringen eller bokføringen som må rettes — ikke avstemmingen.',
  'avf.ov.sources.title': 'Datakilder',
  'avf.ov.sources.incompleteOne': '{count} kilde er ikke komplett for perioden.',
  'avf.ov.sources.incompleteMany': '{count} kilder er ikke komplette for perioden.',
  'avf.ov.sources.allPresent': 'Alle kildene avstemmingen leser er på plass for perioden.',
  'avf.ov.sources.colSource': 'Kilde',
  'avf.ov.sources.colDetails': 'Detaljer',
  'avf.ov.sources.notComplete': 'Ikke komplett',
  'avf.ov.main.title': 'Automatisk hovedavstemming',
  'avf.ov.main.noAccounts': 'Ingen MVA-kontoer å sammenlikne',
  'avf.ov.main.codesMatch': 'MVA-kodene stemmer med hovedboken',
  'avf.ov.main.noActivity': 'Perioden har ingen bevegelse på MVA-kontoene. Uten en konto å sammenlikne med finnes det ingen differanse å avstemme.',
  'avf.ov.main.sameTax': 'Avgiften som følger av MVA-kodene er den samme som er ført på MVA-kontoene i perioden.',
  'avf.ov.main.differentTax': 'Avgiften som følger av MVA-kodene er ikke den samme som er ført på MVA-kontoene. Differansen må forklares før området kan avstemmes.',
  'avf.ov.main.colArea': 'Kontrollområde',
  'avf.ov.main.colCodes': 'MVA-koder',
  'avf.ov.main.colLedger': 'Hovedbok',
  'avf.ov.main.notCompared': 'Ikke sammenliknet',
  'avf.ov.codes.title': 'MVA-koder og rapporteringsgrunnlag',
  'avf.ov.codes.none': 'Ingen MVA-koder med beløp i denne perioden.',
  'avf.ov.codes.explain': 'Grunnlaget er transaksjonene i perioden. Beregnet MVA er grunnlaget ganget med satsen — avviker den fra kodens eget beløp, er avgiften regnet på noe annet enn grunnlaget.',
  'avf.ov.codes.colDescription': 'Beskrivelse',
  'avf.ov.codes.colComputed': 'Beregnet MVA',
  'avf.ov.codes.colBooked': 'Bokført MVA',
  'avf.ov.codes.noRate': 'Ingen sats',
  'avf.ov.accounts.title': 'MVA-kontoer i hovedboken',
  'avf.ov.accounts.none': 'Ingen MVA-konto har saldo eller bevegelse i denne perioden.',
  'avf.ov.accounts.colAccount': 'Kontrollkonto',
  'avf.ov.accounts.colOpening': 'Inngående saldo',
  'avf.ov.accounts.colDebit': 'Debet',
  'avf.ov.accounts.colCredit': 'Kredit',
  'avf.ov.accounts.colClosing': 'Utgående saldo',
  'avf.ov.accounts.colExpected': 'Beregnet fra MVA-koder',
  'avf.ov.accounts.carriedOver': 'Ikke nullstilt fra forrige termin',
  'avf.ov.accounts.noCodePoints': 'Ingen kode peker hit',
  'avf.ov.accounts.open': 'Åpne konto',
  'avf.ov.accounts.sumOutgoing': 'Sum utgående MVA i terminen',
  'avf.ov.accounts.sumIncoming': 'Sum inngående MVA i terminen',
  'avf.ov.accounts.bookedOn': 'Bokført på {accounts}',
  'avf.ov.accounts.carriedNote': '{codes}: saldoen er ikke nullstilt etter forrige termin. Undersøk om beløpet gjelder et oppgjør som ikke er betalt, eller en feilføring.',
  'avf.ov.tile.duplicateVouchers': 'Mulige duplikatbilag',
  'avf.ov.tile.customsMissing': 'Tolldeklarasjon mangler',
  'avf.ov.tile.creditNotesInPeriod': 'Kreditnotaer i perioden',
  'avf.ov.card.title': 'Kontrollkort',
  'avf.ov.card.summary': '{flagged} berørte transaksjoner · {unassessed} ikke ferdig vurdert',
  'avf.ov.card.codesVsLedger': 'MVA-koder mot hovedbok',
  'avf.ov.card.seeMain': 'Se hovedavstemmingen',
  'avf.ov.card.settlementNotCleared': 'Oppgjørskonto ikke nullstilt',
  'avf.ov.card.hide': 'Skjul',
  'avf.ov.card.showAll': 'Vis alle automatiske kontroller',
  'avf.ov.card.activeFilter': 'Aktivt filter: {label} · {count} transaksjoner',
  'avf.ov.card.reset': 'Nullstill',
  'avf.ov.checks.title': 'Automatiske kontroller',
  'avf.ov.checks.note': 'Kontrollene krysser ikke av noe i den faglige sjekklista. De sier hva den som krysser av bør ha sett på.',
  'avf.ov.checks.colCheck': 'Kontroll',
  'avf.ov.checks.colRun': 'Kjøring',
  'avf.ov.checks.colFindings': 'Funn',
  'avf.ov.checks.run': 'Kjørt',
  'avf.ov.checks.findings': '{count} funn',
  'avf.ov.checks.noFindings': 'Ingen funn',
  'avf.tbl.possibleDuplicates': 'Mulige duplikater',
  'avf.tbl.duplicates': 'Duplikater',
  'avf.tbl.foreignReverse': 'Utland/omvendt',
  'avf.tbl.import': 'Import',
  'avf.tbl.sales.totalBasis': 'Samlet salgsgrunnlag',
  'avf.tbl.sales.taxableTurnover': 'Avgiftspliktig omsetning',
  'avf.tbl.sales.outputVat': 'Utgående MVA',
  'avf.tbl.sales.toAssess': 'Transaksjoner til vurdering',
  'avf.tbl.sales.colCustomer': 'Kunde',
  'avf.tbl.sales.colNetBasis': 'Netto grunnlag',
  'avf.tbl.sales.noMatch': 'Ingen salgstransaksjoner passer med filtrene.',
  'avf.tbl.sales.none': 'Ingen salg i denne perioden.',
  'avf.tbl.purchases.totalBasis': 'Samlet kjøpsgrunnlag',
  'avf.tbl.purchases.deductedInputVat': 'Fradragsført inngående MVA',
  'avf.tbl.purchases.withoutDeduction': 'Uten fradragsrett',
  'avf.tbl.purchases.partialDeduction': 'Delvis fradrag',
  'avf.tbl.purchases.toAssess': 'Kjøp til vurdering',
  'avf.tbl.purchases.colSupplier': 'Leverandør',
  'avf.tbl.purchases.noMatch': 'Ingen kjøpstransaksjoner passer med filtrene.',
  'avf.tbl.purchases.none': 'Ingen kjøp i denne perioden.',
  'avf.tbl.control.title': 'Kontroll av transaksjoner',
  'avf.tbl.control.resetFilters': 'Nullstill filtre',
  'avf.tbl.control.noMatch': 'Ingen transaksjoner passer med filtrene.',
  'avf.tbl.control.none': 'Ingen transaksjoner med MVA-virkning i denne perioden.',
  'avf.sec.status.paid': 'Levert og betalt',
  'avf.sec.status.unpaid': 'Levert — ikke betalt',
  'avf.sec.status.upcoming': 'Terminen har ikke startet',
  'avf.sec.status.archive': 'Arkivgrunnlag fra import',
  'avf.sec.status.unknown': 'Ukjent status',
  'avf.sec.noFlags': 'Ingen',
  'avf.sec.moreFlags': '+{count} flere',
  'avf.sec.customs.registered': 'Registrert',
  'avf.sec.customs.notRelevant': 'Ikke relevant',
  'avf.sec.foreign.title': 'Utland, import og omvendt avgiftsplikt',
  'avf.sec.foreign.none': 'Ingen kjøp med omvendt avgiftsplikt eller vareimport i denne perioden.',
  'avf.sec.foreign.count': 'Antall utenlandstransaksjoner',
  'avf.sec.foreign.reverseBasis': 'Grunnlag for omvendt avgiftsplikt',
  'avf.sec.foreign.computedOutput': 'Beregnet utgående MVA',
  'avf.sec.foreign.deductibleInput': 'Fradragsberettiget inngående MVA',
  'avf.sec.foreign.customsRegistered': 'Tolldeklarasjoner registrert',
  'avf.sec.foreign.customsMissing': 'Tolldeklarasjoner som mangler',
  'avf.sec.foreign.colOutput': 'Utg. MVA',
  'avf.sec.foreign.colInput': 'Inng. MVA',
  'avf.sec.foreign.colCustoms': 'Tolldokument',
  'avf.sec.foreign.missingOne': 'Én vareimport har ingen registrert tolldeklarasjon i perioden. Innførselsgrunnlaget kan da ikke kontrolleres mot noe, og innførselsmerverdiavgiften bygger bare på det bokførte beløpet.',
  'avf.sec.foreign.missingMany': '{count} vareimporter har ingen registrert tolldeklarasjon i perioden. Innførselsgrunnlaget kan da ikke kontrolleres mot noe, og innførselsmerverdiavgiften bygger bare på det bokførte beløpet.',
  'avf.sec.foreign.requestCustoms': 'Be klienten om tolldeklarasjon',
  'avf.sec.draft.titleSubmitted': 'Oppsummering av MVA-meldingen',
  'avf.sec.draft.titleDraft': 'Oppsummering av MVA-meldingen (utkast)',
  'avf.sec.draft.badge': 'Utkast',
  'avf.sec.draft.totalOutput': 'Samlet utgående MVA',
  'avf.sec.draft.totalDeductible': 'Samlet inngående MVA til fradrag',
  'avf.sec.draft.importReverse': 'MVA ved import og omvendt avgiftsplikt',
  'avf.sec.draft.importIncomplete': 'Ikke fullstendig — se Utland og import',
  'avf.sec.draft.netRefund': 'Netto MVA til gode',
  'avf.sec.draft.netPayable': 'Netto MVA til betaling',
  'avf.sec.draft.deviation': 'Avvik mot MVA-modellens tall for terminen',
  'avf.sec.draft.submittedNote': 'Meldingen er levert. Avstemmingen kontrollerer at grunnlaget bak den stemmer.',
  'avf.sec.draft.notSentNote': 'Meldingen er ikke sendt — beløpet kan endre seg når kontrollfunnene er behandlet.',
  'avf.sec.filing.noTerm': 'Perioden hører ikke til noen MVA-termin i {year}.',
  'avf.sec.filing.yearFallback': 'året',
  'avf.sec.filing.covers': 'Terminen dekker',
  'avf.sec.filing.netRefund': 'Netto til gode',
  'avf.sec.filing.netToPay': 'Netto å betale',
  'avf.sec.filing.submittedNote': 'Meldingen er levert for terminen. Avstemmingen kontrollerer at grunnlaget bak den stemmer.',
  'avf.sec.filing.notSubmittedNote': 'Meldingen er ikke levert. Den sendes fra klientens egen MVA-side — avstemmingen konkluderer, den rapporterer ikke.',
  'avf.sec.filing.declarations': '{count} tolldeklarasjon(er) er registrert på terminen.',
  'avf.sec.settle.title': 'Oppgjør og betaling',
  'avf.sec.settle.refundAmount': 'Tilgodebeløp',
  'avf.sec.settle.claim': 'Krav ifølge meldingen',
  'avf.sec.settle.refunded': 'Tilbakebetalt',
  'avf.sec.settle.paid': 'Betalt',
  'avf.sec.settle.outstanding': 'Utestående',
  'avf.sec.settle.paymentDeadline': 'Betalingsfrist',
  'avf.sec.settle.refundRow': 'Tilbakebetaling',
  'avf.sec.settle.paymentRow': 'Betaling',
  'avf.sec.settle.noPayment': 'Ingen betaling er registrert på terminen ennå.',
  'avf.sec.settle.cannotFinish': 'Oppgjøret kan ikke ferdigstilles før meldingen er levert og betalingen er registrert.',
  'avf.sec.docs.colUploaded': 'Lastet opp',
  'avf.sec.docs.sourceClient': 'Klienten',
  'avf.sec.docs.sourceFirm': 'Byrået',
  'avf.sec.docs.none': 'Ingen dokumenter er lastet opp på MVA-området for denne perioden.',
  'avf.sec.docs.incompleteBasis': 'Grunnlag som ikke er komplett',
  'avf.chk.derived.missingTreatment': 'Transaksjoner uten fastsatt avgiftsbehandling er behandlet',
  'avf.chk.derived.direct': 'Direkteføringer på MVA-kontoene er vurdert',
  'avf.chk.derived.duplicates': 'Mulige duplikater er vurdert',
  'avf.chk.derived.noDeduction': 'Kjøp uten fradragsrett er vurdert',
  'avf.chk.derived.partialDeduction': 'Kjøp med delvis fradragsrett er vurdert',
  'avf.chk.derived.reverseCharge': 'Omvendt avgiftsplikt er vurdert',
  'avf.chk.derived.customsMissing': 'Vareimport uten tolldeklarasjon er behandlet',
  'avf.chk.derived.salesWithoutVat': 'Salg uten MVA er dokumentert',
  'avf.chk.derived.creditNotes': 'Kreditnotaenes periodisering er vurdert',
  'avf.chk.title': 'Faglig sjekkliste',
  'avf.chk.titleReadOnly': 'Faglig sjekkliste (utførerens, skrivebeskyttet)',
  'avf.chk.none': 'Ingen kontrollpunkter er definert for MVA i denne perioden.',
  'avf.chk.note': 'Punktene gjelder hele MVA-området. En avkryssing lagres på alle MVA-kontoene i perioden.',
  'avf.chk.groupItems': 'Poster som krever behandling',
  'avf.chk.groupAssessments': 'Overordnede faglige vurderinger',
  'avf.chk.groupReady': 'Klarstilling',
  'avf.chk.countOf': '{done} av {total}',
  'avf.chk.processed': '{done} av {total} behandlet',
  'avf.chk.notApplicable': 'Ikke aktuelt denne perioden',
  'avf.chk.followsAssessments': 'Følger av vurderingene',
  'avf.chk.performedBy': 'Utføres av {name}',
  'avf.chk.completed': '{done} av {total} kontrollpunkter fullført',
  'avf.chk.blk.itemsOne': '{count} transaksjon krever vurdering',
  'avf.chk.blk.itemsMany': '{count} transaksjoner krever vurdering',
  'avf.chk.blk.diff': 'MVA-kodene og hovedboken avviker på {areas}',
  'avf.chk.blk.settlement': 'Oppgjørskontoen er ikke nullstilt fra forrige termin',
  'avf.chk.blk.customs': '{count} vareimport mangler tolldeklarasjon',
  'avf.chk.blk.checksOne': '{count} kontrollpunkt gjenstår',
  'avf.chk.blk.checksMany': '{count} kontrollpunkter gjenstår',
  'avf.chk.concl.title': 'Konklusjon og godkjenning',
  'avf.chk.concl.label': 'Konklusjon',
  'avf.chk.concl.placeholder': 'Hva viser gjennomgangen av MVA for denne perioden?',
  'avf.chk.concl.savedAs': 'Lagres som begrunnelsen på kontrollpunktet «{label}».',
  'avf.chk.concl.remainingRisk': 'Gjenstående risiko',
  'avf.chk.concl.nothingLeft': 'Ingenting står igjen som hindrer at området sendes til kontroll.',
  'avf.chk.concl.followUpTitle': 'Oppfølging neste termin',
  'avf.chk.concl.noFollowUps': 'Ingen vurderinger er merket for oppfølging neste termin.',
  'avf.chk.concl.followedUp': 'Følges opp',
  'avf.chk.concl.action': 'Tiltak: {action}',
  'avf.chk.concl.noAction': 'Ingen tiltak notert',
  'avf.chk.concl.due': 'Frist {date}',
  'avf.chk.concl.openAssessment': 'Åpne vurdering',
  'avf.chk.concl.sendToControl': 'Send området til kontroll',
  'avf.chk.concl.oneLeft': 'Én ting står igjen før området kan sendes.',
  'avf.chk.concl.manyLeft': '{count} ting står igjen før området kan sendes.',
  'avf.drw.outputReverse': 'Utgående MVA (omvendt)',
  'avf.drw.reason': 'Faglig begrunnelse',
  'avf.drw.reasonRequired': 'Faglig begrunnelse (påkrevd)',
  'avf.drw.reasonPlaceholder': 'Hvorfor er avgiften behandlet slik, og hva bygger vurderingen på?',
  'avf.drw.action': 'Tiltak',
  'avf.drw.actionPlaceholder': 'F.eks. Rett MVA-kode på bilaget, eller be om dokumentasjon',
  'avf.drw.followUpDeadline': 'Frist for oppfølging',
  'avf.drw.needsReason': 'Denne vurderingen krever en begrunnelse.',
  'avf.drw.save': 'Lagre vurdering',
});
